import { render, staticRenderFns } from "./PirLogs.vue?vue&type=template&id=781f9340&"
import script from "./PirLogs.vue?vue&type=script&lang=js&"
export * from "./PirLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports